import {
  MasonryEngineActionHandler,
  MasonryEngineNodeAction,
} from '@leagueplatform/masonry-engine';
import { MasonryDriverAction } from '@leagueplatform/masonry-renderers';
import { queryHelpers } from '@leagueplatform/genesis-core';

type ChatSelectActionPayload = {
  url?: string;
  nodeIds?: string[];
  extraQueryParams?: Array<{ key: string; value: string }>;
};

export type ChatSelectAction = MasonryEngineNodeAction<
  'chatSelect',
  ChatSelectActionPayload
>;

export const chatSelectActionHandler: MasonryEngineActionHandler<
  ChatSelectAction,
  MasonryDriverAction
> = (action, { invokeAction, messagingController }) => {
  const { payload } = action;

  if (payload.nodeIds) {
    invokeAction({
      type: 'reload',
      namespace: 'default',
      payload: {
        nodeIds: payload.nodeIds,
        renderIntermediately: 'self',
        ...(payload.extraQueryParams && {
          extraQueryParams: payload.extraQueryParams,
        }),
      },
      ancestry: action.ancestry,
    });

    // Deferred to the next frame because on mobile the layout
    // transitions from list to detail view and needs to re-render first.
    const isMobileTablet = window.matchMedia(
      queryHelpers.down('laptop'),
    ).matches;
    requestAnimationFrame(() => {
      if (isMobileTablet) window.scrollTo({ top: 0 });
      messagingController.sendMessage(payload.nodeIds![0], {
        type: 'focus',
        payload: { scroll: false },
      });
    });

    return;
  }

  // url is for Mobile Native deeplink navigation - no-op on web
  if (payload.url) {
    // eslint-disable-next-line no-console
    console.warn('chatSelect: deeplink URL is not handled on web', payload.url);
  }
};
